import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
// import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { HTTP } from '@ionic-native/http'

import { Geolocation } from '@ionic-native/geolocation';

import { MyApp } from './app.component';
// import { HomePage } from '../pages/home/home';
// import { LoginPage } from '../pages/login/login';

import { DIC } from '../pages/dic';
// import { GlobalPage } from '../pages/global/global';
// import { MapviewPage } from '../pages/mapview/mapview';
import { GN } from '../gn';
import { HttpModule } from '@angular/http';
// import { FpassPage } from '../pages/login/fpass';
import { Deeplinks } from '@ionic-native/deeplinks';
import { SocketImplementation } from '../socket';
import { VehicleService } from '../vehicles';
// import { RoutingPage } from '../pages/routing/routing';
// import { ReportsPage } from '../pages/reports/reports';
// import { ChannelPage } from '../pages/channel/channel';
// import { SettingsPage } from '../pages/settings/settings';
import { DatePickerModule } from 'ion-datepicker';
import { PopupPage } from '../pages/popup/popup';
// import { GeneralsettingsPage } from '../pages/settings/generalsettings/generalsettings';
// import { UsersettingsPage } from '../pages/settings/usersettings/usersettings';
import { EditusersettPage } from '../pages/settings/usersettings/editusersett';
// import { PoisettingsPage } from '../pages/settings/poisettings/poisettings';
import { PoimapPage } from '../pages/settings/poisettings/poimap';
import { PoieditPage } from '../pages/settings/poisettings/poiedit';
// import { VehiclesettinngsPage } from '../pages/settings/vehiclesettinngs/vehiclesettinngs';
// import { SearchVehiclesPage } from '../pages/costs/search-vehicles/search-vehicles';
// import { ExpensesPage } from '../pages/costs/expenses/expenses';
import { MessagesPage } from '../pages/messages/messages';
import { NotificationsPage } from '../pages/notifications/notifications';
import { CalendarPage } from '../pages/calendar/calendar';
import { KokpitPage } from '../pages/reports/kokpit/kokpit';
// import { PregledPage } from '../pages/reports/pregled/pregled';
import { RepmapPage } from '../pages/reports/repmap/repmap';
import { Repmap1Page } from '../pages/reports/repmap1/repmap1';
import { RouteonmapPage } from '../pages/routing/routeonmap/routeonmap';
import { ReconstrunctionPage } from '../pages/reports/reconstrunction/reconstrunction';
// import { SusfueldownPage } from '../pages/reports/susfueldown/susfueldown';
// import { ShortPage } from '../pages/reports/short/short';
import { VehicleeditPage } from '../pages/settings/vehiclesettinngs/vehicleedit';
import { LinkvehicletruckingPage } from '../pages/settings/vehiclesettinngs/linkvehicletrucking';
import { ShiftschedulePage } from '../pages/settings/workshift/shiftschedule';
// import { OrganizationunitPage } from '../pages/settings/organizationunit/organizationunit';
import { EditorganizationunitPage } from '../pages/settings/organizationunit/editorganizationunit';
// import { SchedulePage } from '../pages/settings/schedule/schedule';
import { EditschedulePage } from '../pages/settings/schedule/editschedule';
// import { DriversettingsPage } from '../pages/settings/driversettings/driversettings';
import { DriverseditPage } from '../pages/settings/driversettings/driversedit';
// import { DetailPage } from '../pages/reports/detail/detail';
// import { SecuritystatePage } from '../pages/reports/securitystate/securitystate';
// import { TechmalfunctionPage } from '../pages/reports/techmalfunction/techmalfunction';
// import { DrivervehiclePage } from '../pages/reports/drivervehicle/drivervehicle';
// import { WeaksatellitesPage } from '../pages/reports/weaksatellites/weaksatellites';
import { PopupaddvehiclePage } from '../pages/settings/driversettings/popupaddvehicle';
import { AlertsaddPage } from '../pages/settings/alerts/alertsadd';
import { EditdrivergradePage } from '../pages/settings/vehiclesettinngs/editdrivergrade/editdrivergrade';
import { EditvehshiftsPage } from '../pages/settings/editvehshifts/editvehshifts';
// import { AlertsPage } from '../pages/settings/alerts/alerts';
// import { BeaconsettingsPage } from '../pages/settings/beaconsettings/beaconsettings';
import { EditbeaconsettingsPage } from '../pages/settings/beaconsettings/editbeaconsettings';

// import { PastdistancePage } from '../pages/reports/pastdistance/pastdistance';
// import { ActivityPage } from '../pages/reports/activity/activity';
// import { MaxspeedPage } from '../pages/reports/maxspeed/maxspeed';
// import { SpeedexcessPage } from '../pages/reports/speedexcess/speedexcess';
// import { ShiftoverviewPage } from '../pages/reports/shiftoverview/shiftoverview';
import { ShiftonmapPage } from '../pages/reports/shiftonmap/shiftonmap';
// import { RfiddriverPage } from '../pages/reports/rfiddriver/rfiddriver';

// import { IdlePage } from '../pages/reports/idle/idle';
// import { Taxi1Page } from '../pages/reports/taxi1/taxi1';
// import { LogsreportPage } from '../pages/settings/logsreport/logsreport';
// import { ShiftscheduleoverviewPage } from '../pages/settings/shiftscheduleoverview/shiftscheduleoverview';

import { AddzonePage } from '../pages/mapview/addzone/addzone';
import { AddpoimapPage } from '../pages/mapview/addpoimap/addpoimap';
// import { Taxi2Page } from '../pages/reports/taxi2/taxi2';
// import { FmoverviewPage } from '../pages/reports/fmoverview/fmoverview';
// import { FmcostsPage } from '../pages/reports/fmcosts/fmcosts';
// import { FmfuelPage } from '../pages/reports/fmfuel/fmfuel';
// import { FmservicePage } from '../pages/reports/fmservice/fmservice';
// import { FmothcostsPage } from '../pages/reports/fmothcosts/fmothcosts';
// import { FmfullreportPage } from '../pages/reports/fmfullreport/fmfullreport';
// import { FmtiresalertPage } from '../pages/reports/fmtiresalert/fmtiresalert';
// import { FmservicealertPage } from '../pages/reports/fmservicealert/fmservicealert';
// import { FmtagexpirealertPage } from '../pages/reports/fmtagexpirealert/fmtagexpirealert';
import { LoadpredefinedPage } from '../pages/routing/loadpredefined/loadpredefined';
import { LoadzonesroutingPage } from '../pages/routing/loadzonesrouting/loadzonesrouting';
import { EditroutePage } from '../pages/routing/editroute/editroute';
import { NotificationmodalPage } from '../pages/notificationmodal/notificationmodal';
import { CostsPage } from '../pages/costs/costs';
import { SetdrivershiftPage } from '../pages/setdrivershift/setdrivershift';
import { GarminlivePage } from '../pages/mapview/garminlive/garminlive';
// import { WorktimePage } from '../pages/reports/worktime/worktime';
// import { AlarmreportPage } from '../pages/reports/alarmreport/alarmreport';
// import { VisitedpoiPage } from '../pages/reports/visitedpoi/visitedpoi';

import { AmChartsModule } from "@amcharts/amcharts3-angular";
import { WelcomemsgPage } from '../pages/welcomemsg/welcomemsg';
import { NopayalarmPage } from '../pages/nopayalarm/nopayalarm';
import { FeedbackPage } from '../pages/feedback/feedback';
import { EditprivPage } from '../pages/settings/usersettings/editpriv';
// import { AgrculturePage } from '../pages/settings/agrculture/agrculture';
import { EditagrculturePage } from '../pages/settings/agrculture/editagrculture/editagrculture';
import { Editagrculture1Page } from '../pages/settings/agrculture/editagrculture1/editagrculture1';
import { ChooseprocessesPage } from '../pages/settings/agrculture/chooseprocesses/chooseprocesses';
// import { AgrmaterialPage } from '../pages/settings/agrmaterial/agrmaterial';
// import { AgrmechanPage } from '../pages/settings/agrmechan/agrmechan';
import { EditagrmechanPage } from '../pages/settings/agrmechan/editagrmechan/editagrmechan';
// import { IndoorpausetypesPage } from '../pages/settings/indoorpausetypes/indoorpausetypes';
// import { IndoorquestionsPage } from '../pages/settings/indoorquestions/indoorquestions';
import { EditindoorpausetypesPage } from '../pages/settings/indoorpausetypes/editindoorpausetypes/editindoorpausetypes';
import { EditindoorquestionsPage } from '../pages/settings/indoorquestions/editindoorquestions/editindoorquestions';
// import { AgroperationPage } from '../pages/settings/agroperation/agroperation';
// import { IndoorprocessesPage } from '../pages/settings/indoorprocesses/indoorprocesses';
import { EditindoorprocessesPage } from '../pages/settings/indoorprocesses/editindoorprocesses/editindoorprocesses';
import { GlhomePage } from '../pages/gps-link/glhome/glhome';
import { GlmapviewPage } from '../pages/gps-link/glmapview/glmapview';
import { AddpoiPage } from '../pages/addpoi/addpoi';
import { PNMaps } from '../pan.maps';
//import { ProgressroutesPage } from '../pages/progressroutes/progressroutes';
// import { ReportgeneratorPage } from '../pages/reports/reportgenerator/reportgenerator';
// import { ProtocolgeneratorPage } from '../pages/reports/protocolgenerator/protocolgenerator';
import { AddreportPage } from '../pages/reports/addreport/addreport';
import { AddprotocolPage } from '../pages/reports/addprotocol/addprotocol';
// import { WorkshiftPage } from '../pages/settings/workshift/workshift';
import { WorkshifteditPage } from '../pages/settings/workshift/workshiftedit';
import { VehshiftsmodifyPage } from '../pages/settings/editvehshifts/vehshiftsmodify/vehshiftsmodify';

import { EditroutenumberingPage } from '../pages/settings/generalsettings/editroutenumbering/editroutenumbering';
// import { HolidayPage } from '../pages/settings/holiday/holiday';
import { AddholidayPage } from '../pages/settings/holiday/addholiday';
import { AllholidaysPage } from '../pages/settings/holiday/allholidays';
import { PricesbydayPage } from '../pages/settings/energycalendar/pricesbyday';

// import { InterventionPage } from '../pages/reports/intervention/intervention';
// import { TowreportPage } from '../pages/reports/towreport/towreport';
// import { DigalkaanalogreportPage } from '../pages/reports/digalkaanalogreport/digalkaanalogreport';
// import { TachogramPage } from '../pages/reports/tachogram/tachogram';
// import { IndoorbeaconreportPage } from '../pages/reports/indoorbeaconreport/indoorbeaconreport';
// import { BeaconreportPage } from '../pages/reports/beaconreport/beaconreport';
// import { AgrreportPage } from '../pages/reports/agrreport/agrreport';
// import { GarminmessagesPage } from '../pages/reports/garminmessages/garminmessages';
// import { GarminstopstatusPage } from '../pages/reports/garminstopstatus/garminstopstatus';
// import { SecurityprotocolPage } from '../pages/reports/securityprotocol/securityprotocol';
// import { FuelreportPage } from '../pages/reports/fuelreport/fuelreport';
// import { WeaponsPage } from '../pages/settings/weapons/weapons';
import { EditweaponsPage } from '../pages/settings/weapons/editweapons';
import { JobsPage } from '../pages/settings/jobs/jobs';
import { EditjobsPage } from '../pages/settings/jobs/editjobs';
import { RoutebankPage } from '../pages/routing/routebank/routebank';
import { RouteindoorPage } from '../pages/routing/routeindoor/routeindoor';
import { NeworderbankPage } from '../pages/routing/routebank/neworderbank/neworderbank';
import { PreorderbankPage } from '../pages/routing/routebank/preorderbank/preorderbank';
import { ReportorderbankPage } from '../pages/routing/routebank/reportorderbank/reportorderbank';
import { ChoosedriverbankPage } from '../pages/routing/routebank/choosedriverbank/choosedriverbank';
import { PrintreportPage } from '../pages/routing/routebank/reportorderbank/printreport';

import { NeworderindoorPage } from '../pages/routing/routeindoor/neworderindoor/neworderindoor';
import { PreorderindoorPage } from '../pages/routing/routeindoor/preorderindoor/preorderindoor';
import { ManageordersPage } from '../pages/routing/routeindoor/manageorders/manageorders';
import { OrderpriorityPage } from '../pages/routing/routeindoor/manageorders/orderpriority/orderpriority';
import { OrderdelegatePage } from '../pages/routing/routeindoor/manageorders/orderdelegate/orderdelegate';
import { QualitycontrolPage } from '../pages/routing/routeindoor/qualitycontrol/qualitycontrol';
import { QualitycontrolquestionsPage } from '../pages/routing/routeindoor/qualitycontrol/qualitycontrolquestions/qualitycontrolquestions';
import { LoadimportedPage } from '../pages/routing/routeindoor/loadimported/loadimported';

import { PoinotePage } from '../pages/poinote/poinote';
import { BankpickupPage } from '../pages/bankpickup/bankpickup';
import { HistorylognalogPage } from '../pages/routing/routebank/reportorderbank/historylognalog';
import { RoutingnalogbankPage } from '../pages/routing/routebank/reportorderbank/routingnalogbank';

import { ColorPickerModule } from 'ngx-color-picker';
import { FueldropdetailsPage } from '../pages/fueldropdetails/fueldropdetails';
import { ConfirmreqPage } from '../pages/confirmreq/confirmreq';
// import { DriverreportPage } from '../pages/reports/driverreport/driverreport';
// import { DriverdataPage } from '../pages/reports/driverdata/driverdata';
// import { DriveranalyticsPage } from '../pages/reports/driveranalytics/driveranalytics';
// import { DriverscorePage } from '../pages/reports/driverscore/driverscore';
// import { DriverbehaviorPage } from '../pages/reports/driverbehavior/driverbehavior';
import { ChatsPage } from '../pages/messages/chats';
import { DestinationPage } from '../pages/destination/destination';
import { ClinicPage } from '../pages/clinic/clinic';
import { Clinic1oldPage } from '../pages/clinic1old/clinic1old';
import { IndoorpersonPage } from '../pages/indoorperson/indoorperson';
import { IndoorassetPage } from '../pages/indoorasset/indoorasset';
import { ClinicopenroomPage } from '../pages/clinicopenroom/clinicopenroom';
import { SuccsavedorderPage } from '../pages/succsavedorder/succsavedorder';
// import { OneSignal } from '@ionic-native/onesignal';
import { SearchemployeePage } from '../pages/routing/routebank/choosedriverbank/searchemployee';

import { ExcludearmPage } from '../pages/excludearm/excludearm';
// import { ArmdisarmreportPage } from '../pages/settings/armdisarmreport/armdisarmreport';
// import { RoaddirectionsPage } from '../pages/settings/roaddirections/roaddirections';
import { RoaddirectionseditPage } from '../pages/settings/roaddirections/roaddirectionsedit';
import { ChooseroaddirectionPage } from '../pages/chooseroaddirection/chooseroaddirection';
import { ChoosedriverPage } from '../pages/choosedriver/choosedriver';
import { ChooseindoorpausePage } from '../pages/chooseindoorpause/chooseindoorpause';
import { VehicledatalivePage } from '../pages/mapview/vehicledatalive/vehicledatalive';
import { TachogramlivePage } from '../pages/mapview/tachogramlive/tachogramlive';
// import { MycostsPage } from '../pages/settings/mycosts/mycosts';
// import { MycomponentsPage } from '../pages/settings/mycomponents/mycomponents';
// import { MysupplierPage } from '../pages/settings/mysupplier/mysupplier';
import { AddtickedPage } from '../pages/ticket/addticked';
import { ViewtickedPage } from '../pages/ticket/viewticked';
import { InforeconstructionPage } from '../pages/reports/reconstrunction/inforeconstruction';
import { ShowpoiroutePage } from '../pages/showpoiroute/showpoiroute';
import { MapviewMapview2Page } from '../pages/mapview-mapview2/mapview-mapview2';
import { CurrentfuturebanknalogPage } from '../pages/routing/routebank/reportorderbank/currentfuturebanknalog';
import { HistoryviewnalogbankPage } from '../pages/routing/routebank/reportorderbank/historyviewnalogbank';

import { HistoryviewnalogindoorPage } from '../pages/routing/routeindoor/reportorderindoor/historyviewnalogindoor';
import { ShowhistoryPage } from '../pages/routing/routeindoor/reportorderindoor/showhistory/showhistory';

// import { PredefinednotesPage } from '../pages/settings/predefinednotes/predefinednotes';
import { EditpredefinednotesPage } from '../pages/settings/predefinednotes/editpredefinednotes';
// import { FuelpulsesvehreportPage } from '../pages/reports/fuelpulsesvehreport/fuelpulsesvehreport';
// import { FuelleveltankPage } from '../pages/reports/fuelleveltank/fuelleveltank';
// import { Fuelleveltank1Page } from '../pages/reports/fuelleveltank1/fuelleveltank1';
import { CalcdistancePage } from '../pages/mapview/calcdistance/calcdistance';
import { RoutemomentkokpitPage } from '../pages/routing/routemomentkokpit/routemomentkokpit';
import { EditgrouppoiPage } from '../pages/settings/poisettings/editgrouppoi';
import { BankofficialsPage } from '../pages/settings/poisettings/bankofficials/bankofficials';
import { EditbankofficialsPage } from '../pages/settings/poisettings/bankofficials/editbankofficials';
// import { SumdataroutingreportPage } from '../pages/reports/sumdataroutingreport/sumdataroutingreport';
// import { RoutingvehiclesPage } from '../pages/reports/routingvehicles/routingvehicles';
// import { RoutingdriversPage } from '../pages/reports/routingdrivers/routingdrivers';
// import { RoutingunvisitedpoiPage } from '../pages/reports/routingunvisitedpoi/routingunvisitedpoi';
// import { BluetoothtempPage } from '../pages/reports/bluetoothtemp/bluetoothtemp';
// import { MovementsensorPage } from '../pages/reports/movementsensor/movementsensor';
// import { BadvehicledrivingPage } from '../pages/reports/badvehicledriving/badvehicledriving';
// import { TrafficrulesPage } from '../pages/reports/trafficrules/trafficrules';
import { AlerttypesPage } from '../pages/settings/alerts/alerttypes/alerttypes';
import { EditpinemployeePage } from '../pages/settings/pinemployee/editpinemployee/editpinemployee';
// import { PinemployeePage } from '../pages/settings/pinemployee/pinemployee';
import { File } from '@ionic-native/file';
import { Transfer } from '@ionic-native/transfer';
import { FilePath } from '@ionic-native/file-path';
// import { Camera } from '@ionic-native/camera';


//import { RichTextComponent } from '../components/rich-text/rich-text';
import { Camera } from '@ionic-native/camera';
import { HttpClientModule } from '@angular/common/http';
import { ImgcostsPage } from '../pages/costs/imgcosts/imgcosts';
import { ImagepreviewPage } from '../pages/reports/imagepreview/imagepreview';
import { PinemployeehomePage } from '../pages/pinemployeehome/pinemployeehome';
import { BeaconprocesshomePage } from '../pages/beaconprocesshome/beaconprocesshome';
import { BarcodeScanner } from '@ionic-native/barcode-scanner';
import { WorkorderspinPage } from '../pages/workorderspin/workorderspin';

//mebevi salon
import { SearcharticlesPage } from '../pages/mebelvisalon/searcharticles/searcharticles';
import { ShowmorearticlesPage } from '../pages/mebelvisalon/showmorearticles/showmorearticles';
import { ShowonearticlePage } from '../pages/mebelvisalon/showonearticle/showonearticle';
import { MebelvisalonPage } from '../pages/mebelvisalon/mebelvisalon';
import { PriemnicaPage } from '../pages/magacin/priemnica/priemnica';
import { IspratnicaPage } from '../pages/magacin/ispratnica/ispratnica';
import { MagacinpopisPage } from '../pages/magacin/magacinpopis/magacinpopis';
import { NavigatePage } from '../pages/magacin/navigate/navigate';
// import { IndooremployeePage } from '../pages/reports/indooremployee/indooremployee';
// import { IndoorarticlePage } from '../pages/reports/indoorarticle/indoorarticle';
// import { IndoorprocesiPage } from '../pages/reports/indoorprocesi/indoorprocesi';
// import { IndoorrepPage } from '../pages/reports/indoorrep/indoorrep';
// import { ElectricvehrepPage } from '../pages/reports/electricvehrep/electricvehrep';
import { AutomaticroutePage } from '../pages/routing/automaticroute/automaticroute';
import { EmployeevehPage } from '../pages/settings/driversettings/employeeveh/employeeveh';
import { PinpopoverPage } from '../pages/pinpopover/pinpopover';
import { PopupadddriverPage } from '../pages/settings/vehiclesettinngs/popupadddriver/popupadddriver';

@NgModule({
  declarations: [
    MyApp, PopupPage, EditusersettPage, KokpitPage, PoimapPage, PoieditPage, MessagesPage, NotificationsPage, CalendarPage, RepmapPage, LinkvehicletruckingPage, PopupaddvehiclePage, AlertsaddPage, EditdrivergradePage, EditvehshiftsPage, VehicleeditPage,
    EditorganizationunitPage, EditschedulePage, DriverseditPage, AddzonePage, AddpoimapPage,
    LoadpredefinedPage, LoadzonesroutingPage, EditroutePage, NotificationmodalPage, CostsPage, WelcomemsgPage, NopayalarmPage, FeedbackPage, EditprivPage, EditindoorpausetypesPage, EditindoorquestionsPage, GlhomePage, GlmapviewPage, AddpoiPage,
    AddreportPage, EditweaponsPage, JobsPage, EditjobsPage, WorkshifteditPage, VehshiftsmodifyPage, EditroutenumberingPage, AddholidayPage, AllholidaysPage, PricesbydayPage, RoutebankPage, NeworderbankPage, PreorderbankPage, ReportorderbankPage, ChoosedriverbankPage, PrintreportPage, HistorylognalogPage, RoutingnalogbankPage, FueldropdetailsPage,
    ConfirmreqPage, DestinationPage, SuccsavedorderPage, ChatsPage, SearchemployeePage, ExcludearmPage, RoaddirectionseditPage, ChooseroaddirectionPage, ChoosedriverPage, ChooseindoorpausePage, ViewtickedPage, AddtickedPage, InforeconstructionPage, ShowpoiroutePage, MapviewMapview2Page,
    PoinotePage, BankpickupPage, CurrentfuturebanknalogPage, HistoryviewnalogbankPage, EditpredefinednotesPage, CalcdistancePage, RoutemomentkokpitPage, RouteonmapPage, EditgrouppoiPage, EditbankofficialsPage, BankofficialsPage, VehicledatalivePage,
    Repmap1Page, TachogramlivePage, EditbeaconsettingsPage, ClinicPage, Clinic1oldPage, IndoorpersonPage, IndoorassetPage, ClinicopenroomPage, ShiftschedulePage,
    AddprotocolPage, GarminlivePage, SetdrivershiftPage, ShiftonmapPage, AlerttypesPage, EditpinemployeePage, EditagrmechanPage, ImgcostsPage, ImagepreviewPage, PinemployeehomePage, BeaconprocesshomePage, PreorderindoorPage, ManageordersPage,
    OrderpriorityPage, OrderdelegatePage, QualitycontrolPage, QualitycontrolquestionsPage, RouteindoorPage, NeworderindoorPage, HistoryviewnalogindoorPage, LoadimportedPage, WorkorderspinPage, EditagrculturePage, EditindoorprocessesPage, ShowhistoryPage, Editagrculture1Page, ChooseprocessesPage, /*mebelvi salon*/SearcharticlesPage, ShowmorearticlesPage, ShowonearticlePage, MebelvisalonPage,
    PriemnicaPage, IspratnicaPage, MagacinpopisPage, NavigatePage, AutomaticroutePage, EmployeevehPage, PinpopoverPage, PopupadddriverPage, ReconstrunctionPage
  ],
  imports: [
    BrowserModule, HttpModule, AmChartsModule, ColorPickerModule, HttpClientModule,
    IonicModule.forRoot(MyApp, { mode: 'md' }), DatePickerModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp, PopupPage, EditusersettPage, KokpitPage, PoimapPage, PoieditPage, MessagesPage, NotificationsPage, CalendarPage, RepmapPage, LinkvehicletruckingPage, PopupaddvehiclePage, AlertsaddPage, EditdrivergradePage, EditvehshiftsPage, VehicleeditPage,
    EditorganizationunitPage, EditschedulePage, DriverseditPage, AddzonePage, AddpoimapPage,
    LoadpredefinedPage, LoadzonesroutingPage, EditroutePage, NotificationmodalPage, CostsPage, WelcomemsgPage, NopayalarmPage, FeedbackPage, EditprivPage, EditindoorpausetypesPage, EditindoorquestionsPage, GlhomePage, GlmapviewPage, AddpoiPage,
    AddreportPage, EditweaponsPage, JobsPage, EditjobsPage, WorkshifteditPage, VehshiftsmodifyPage, EditroutenumberingPage, AddholidayPage, AllholidaysPage, PricesbydayPage, RoutebankPage, NeworderbankPage, PreorderbankPage, ReportorderbankPage, ChoosedriverbankPage, PrintreportPage, HistorylognalogPage, RoutingnalogbankPage, FueldropdetailsPage,
    ConfirmreqPage, DestinationPage, SuccsavedorderPage, ChatsPage, SearchemployeePage, ExcludearmPage, RoaddirectionseditPage, ChooseroaddirectionPage, ChoosedriverPage, ChooseindoorpausePage, ViewtickedPage, AddtickedPage, InforeconstructionPage, ShowpoiroutePage, MapviewMapview2Page,
    PoinotePage, BankpickupPage, CurrentfuturebanknalogPage, HistoryviewnalogbankPage, EditpredefinednotesPage, CalcdistancePage, RoutemomentkokpitPage, RouteonmapPage, EditgrouppoiPage, EditbankofficialsPage, BankofficialsPage, VehicledatalivePage,
    Repmap1Page, TachogramlivePage, EditbeaconsettingsPage, ClinicPage, Clinic1oldPage, IndoorpersonPage, IndoorassetPage, ClinicopenroomPage, ShiftschedulePage,
    AddprotocolPage, GarminlivePage, SetdrivershiftPage, ShiftonmapPage, AlerttypesPage, EditpinemployeePage, EditagrmechanPage, ImgcostsPage, ImagepreviewPage, PinemployeehomePage, BeaconprocesshomePage, PreorderindoorPage, ManageordersPage,
    OrderpriorityPage, OrderdelegatePage, QualitycontrolPage, QualitycontrolquestionsPage, RouteindoorPage, NeworderindoorPage, HistoryviewnalogindoorPage, LoadimportedPage, WorkorderspinPage, EditagrculturePage, EditindoorprocessesPage, ShowhistoryPage, Editagrculture1Page, ChooseprocessesPage, /*mebelvi salon*/SearcharticlesPage, ShowmorearticlesPage, ShowonearticlePage, MebelvisalonPage,
    PriemnicaPage, IspratnicaPage, MagacinpopisPage, NavigatePage, AutomaticroutePage, EmployeevehPage, PinpopoverPage, PopupadddriverPage, ReconstrunctionPage
  ],
  providers: [
    StatusBar, DIC, GN, SocketImplementation, VehicleService, PNMaps, HTTP,

    Deeplinks, Geolocation, Camera, BarcodeScanner,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    File,
    Transfer,
    // Camera,
    FilePath
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts